export const CHANGE_SELECTED_EVENT = "CHANGE_SELECTED_EVENT";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
